export const moveToFolderNewFolderText = "hac";
export const moveToArchiveMbxFolderNewFolderText = "iac";
export const searchFolder = "jac";
export const searchArchiveFolder = "kac";
export const moveToSearchSharedFolder = "lac";
export const moveToFolderCreateNewText = "mac";
export const moveToArchiveMbxFolderCreateNewText = "nac";
export const rootFolderString = "oac";
export default {moveToFolderNewFolderText,moveToArchiveMbxFolderNewFolderText,searchFolder,searchArchiveFolder,moveToSearchSharedFolder,moveToFolderCreateNewText,moveToArchiveMbxFolderCreateNewText,rootFolderString};